// extracted by mini-css-extract-plugin
module.exports = {"info":"style__info__Zcgyf"};